<template>
  <div class="user">
    <h3 class="title">
      {{ $t('delete.head')}}
    </h3>
    <p>
      {{ $t('delete.subhead')}}
    </p>
    <p class="red">
      {{ $t('delete.warning')}}
    </p>
    <p>
      {{ $t('delete.action')}}
    </p>
    <p>
      <input type="text" v-model="email">
    </p>
    <p>
      <button class="btn delete" @click="submit">
        {{ $t('delete.btn.delete')}}
      </button>
      <router-link :to="{name: 'User'}"  class="btn cancel">
        {{ $t('delete.btn.cancel')}}
      </router-link>
    </p>
  </div>
</template>

<script>
import deleteAccount from '../api'

export default {
  data () {
    return {
      email: null
    }
  },
  created () {
    this.$Progress.finish()
  },
  methods: {
    submit () {
      if (this.emailMatches()) {
        deleteAccount(this.email)
          .then((r) => {
            localStorage.removeItem('vuex')
            this.$router.push({name: 'Login'})
          })
      } else {
        alert(`Email doesn't match your user account.`)
      }
    },
    emailMatches () {
      return this.email === this.$store.state.user.email
    }
  }
}
</script>

<style lang="stylus" scoped>
.user
  max-width 600px
  input
    font-size 2em
    padding 0.5em
    width 100%
  .btn
    padding 1em
    margin-top 3em
    text-decoration none
    &.delete
      background-color red
      border solid 1px white
      color white
    &.cancel
      background-color gray
      border solid 1px white
      color white
      float right
  .red
    color red
</style>



// WEBPACK FOOTER //
// src/components/UserDelete.vue